/* =========================================================================
   SAMSARA — ARTICLE-PROGRESS.JS
   Sprint 5 / T9 — Reading progress indicator pentru article pages.
   Top-of-viewport bar care reflectă scroll position relativ la
   article-content body (NU întreaga pagină — exclude hero + footer).

   Vanilla, ~40 lines. rAF throttled scroll listener.
   ========================================================================= */

(function () {
  'use strict';

  function init() {
    const bar = document.querySelector('[data-article-progress-bar]');
    const progress = document.querySelector('[data-article-progress]');
    const content = document.querySelector('[data-article-content]');
    if (!bar || !progress || !content) return;

    let ticking = false;

    function update() {
      const rect = content.getBoundingClientRect();
      const viewportH = window.innerHeight;
      const contentTop = window.scrollY + rect.top;
      const contentEnd = contentTop + rect.height - viewportH;

      let pct = 0;
      if (window.scrollY >= contentTop && window.scrollY <= contentEnd) {
        pct = ((window.scrollY - contentTop) / (contentEnd - contentTop)) * 100;
      } else if (window.scrollY > contentEnd) {
        pct = 100;
      }

      pct = Math.max(0, Math.min(100, pct));
      bar.style.transform = 'scaleX(' + (pct / 100) + ')';
      progress.setAttribute('aria-valuenow', String(Math.round(pct)));
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
